import { types } from "./types";

export const getMasterBadges = (payload) => ({
  type: types.GET_ALL_MASTER_BADGES,
  ...payload,
});
